export const AGENT_CONTAINER_WIDTH = 270;
export const GAP = 30;
export const SKELETON_COUNT = 11;
export const ONE_COLUMN_BREAKPOINT = 928;
export const GRID_PADDING_COUNT = 11;
export const MAX_FILES_UPLOAD = 5;
export const MAX_FILE_SIZE = 20 * 1024 * 1024;
export const AGENT_STARTER_MESSAGE_MAX_LENGTH = 45;
export const AGENT_STARTER_MESSAGE_MAX_WORD = 20;
export const AGENT_NAME_MAX_LENGTH = 80;
export const AGENT_INSTRUCTION_MAX_LENGTH = 20000;
export const AGENT_TEXT_KNOWLEDGE_MAX_LENGTH = 80000;
export const AGENT_DEFAULT_NAME = 'My Agent';
export const AGENT_NAME_PLACEHOLDER = 'e.g Cassia';
export const ALL_TOPICS = 'All topics';
export const OTHERS_TOPICS = 'Others';
export const ALL_INTENTS = 'All intents';
export const ALL_SENTIMENTS = 'All sentiments';
export const NEGATIVE_SENTIMENTS = 'Negative sentiments';
export const POSITIVE_SENTIMENTS = 'Positive sentiments';
export const MAX_TABLE_ITEMS = 10;

export const DEFAULT_TOP_AVATARS = [
    'v2_public_amber@Y5K02DLS4m',
    'v2_public_Alyssa_NoHands_RedSuite_Lobby@qtzjxMSwEa',
    'v2_public_Alyssa_NoHands_BlackShirt_Home@Mvn6Nalx90',
];
export const DEFAULT_AVATARS_GROUPING = {
    'v2_public_Kayla_NoHands_BlackShirt_CoffeeShop@u1un3hTUDJ': ['v2_public_Kayla_NoHands_BlackShirt_Lab@DBhQkMdJDF'],
    'v2_public_alyssa_red_suite_lobby@eRGtappQAP': ['v2_public_alyssa_red_suite_green_screen@46XonMxLFm'],
    'v2_public_anita_pink_shirt_classroom@w0TKk10XrO': ['v2_public_anita_pink_shirt_green_screen@pw9Otj5BPp'],
    'v2_public_dylan_dark_grey_shirt_nature@4DwMS4ibcR': ['v2_public_dylan_dark_grey_shirt_green_screen@rPjBhdodCN'],
    'v2_public_dylan_grey_suite_lobby@veRJGS_iOD': ['v2_public_dylan_grey_suite_green_screen_1@KHlzCjIFiH'],
    'v2_public_ella_pink_shirt_classroom@wmnCN4_87Q': ['v2_public_ella_pink_shirt_green_screen@80Rz4oeQpJ'],
    'v2_public_eugene_black_shirt_lobby@CthhIOV7vW': ['v2_public_eugene_black_shirt_green_screen@KyBpBkaXPX'],
    'v2_public_fiona_black_jacket_classroom@oVIoDEHlh1': ['v2_public_fiona_black_jacket_green_screen@477B7MX1Vf'],
    'v2_public_fiona_blue_shirt_lab@FQBA_hemBB': ['v2_public_fiona_blue_shirt_green_screen@4411G8YCuN'],
    'v2_public_fiona_pink_shirt_nature@YbSy_eGr0t': ['v2_public_fiona_pink_shirt_green_screen@wGfcUyVsfT'],
    'v2_public_joseph_grey_suite_coffeeshop@7fiPyaDUIq': ['v2_public_joseph_grey_suite_green_screen@yypxo8rFtH'],
    'v2_public_lana_black_suite_classroom@kOgpJoXaCn': ['v2_public_lana_black_suite_green_screen@BTQAFVuIxZ'],
    'v2_public_rian_red_jacket_lobby@Lnoj8R5x9r': ['v2_public_rian_red_jacket_green_screen@3EZaK9HIf0'],
    'v2_public_diana_purple_shirt_1_lobby@L0b13iZZAl': [
        'v2_public_diana_purple_shirt_1_hospital@0ICbk6FDig',
        'v2_public_diana_purple_shirt_1_green_screen@HiT0penpLE',
    ],
};
